import { useState } from "react";
import { Layout } from "antd";
import { Web3Store } from "../../stores/web3Store";
import { observer } from "mobx-react";
import { Select } from "antd";
import { ConnectedWallet } from "../connectWallet/connectedWallet";
import "./index.less";

interface IProps {
    web3Store: Web3Store;
}

const Impl = ({ web3Store }: IProps) => {
    const { Header } = Layout;
    const { Option } = Select;
    const [lang, setLang] = useState("EN");
    const changeLang = (val: string) => {
        setLang(val)
    }
    return (
        <Header className="layout-header flex-row" >
            <span className="language-container">
                <i className="iconfont icon-global"></i>
                <Select value={lang} className="language-selector" onChange={changeLang}>
                    {/* <Option val="CN" key="CN">CN</Option> */}
                    <Option val="EN" key="EN">EN</Option>
                </Select>
            </span>
            <ConnectedWallet web3Store={web3Store} />
        </Header>
    );
};

const NavHeader = observer(Impl);

export default NavHeader;
